import axios from "axios";
import { BASE_URL } from "../../../services/api";

const PUBLIC_PROCUREMENT_BASE = `${BASE_URL}/api/v1/procurement/public`;

export const getInvitePreview = async (inviteToken) => {
  const response = await axios.get(
    `${PUBLIC_PROCUREMENT_BASE}/vendors/invite-preview/${encodeURIComponent(inviteToken)}`,
  );
  return response.data;
};

export const selfRegisterVendor = async (payload) => {
  const response = await axios.post(
    `${PUBLIC_PROCUREMENT_BASE}/vendors/self-register`,
    payload,
  );
  return response.data;
};

export default {
  getInvitePreview,
  selfRegisterVendor,
};
